function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M42 25.6667C45.866 25.6667 49 22.5327 49 18.6667C49 14.8007 45.866 11.6667 42 11.6667C38.134 11.6667 35 14.8007 35 18.6667C35 22.5327 38.134 25.6667 42 25.6667Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.1667 29.1666H42C40.2255 29.1642 38.4699 29.5311 36.845 30.2442C35.2201 30.9572 33.7614 32.0007 32.5617 33.3083C34.907 36.5055 36.1701 40.3681 36.1667 44.3333V45.5H56V42C56.001 40.3144 55.6697 38.6452 55.0251 37.0877C54.3805 35.5303 53.4352 34.1151 52.2434 32.9233C51.0515 31.7314 49.6364 30.7861 48.0789 30.1415C46.5215 29.4969 44.8523 29.1657 43.1667 29.1666Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.3333 25.6667C21.488 25.6667 25.6667 21.488 25.6667 16.3333C25.6667 11.1787 21.488 7 16.3333 7C11.1787 7 7 11.1787 7 16.3333C7 21.488 11.1787 25.6667 16.3333 25.6667Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5 29.1667H15.1667C13.1749 29.1666 11.2027 29.5589 9.36257 30.321C7.52244 31.0832 5.85045 32.2004 4.44209 33.6087C3.03372 35.0171 1.91655 36.6891 1.15438 38.5292C0.392202 40.3694 -5.6684e-05 42.3416 6.14387e-09 44.3333L6.14386e-09 49H32.6667V44.3333C32.6653 40.3113 31.067 36.4544 28.223 33.6104C25.379 30.7664 21.522 29.168 17.5 29.1667Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 56,
  height: 56,
  fill: "black"
})));

var SvgGroupDefaultProfileLogo = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGroupDefaultProfileLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/group-default-profile-logo.681217e7.svg";
export { ForwardRef as ReactComponent };